export const useDownloadApp = () => {
  window.open(`https://apps.apple.com/ar/app/artplacer/id1083122176`)
}
export const useGetItOn = () => {
  window.open(
    `https://play.google.com/store/apps/details?id=com.artplacer.artplacer`,
  )
}
